import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { AdSupplierGroupUser } from '@magnetar/admin-api-interfaces'

interface AdSupplierGroupUserResponse {
  success: boolean
  data: AdSupplierGroupUser | null
  error?: {
    code: string
    message: string
  }
}

interface CreateAdSupplierGroupUserByAccountRequest {
  ad_supplier_group_id: number
  account: string
  user_role_id?: number
}

interface CreateNewUserAndAddToGroupRequest {
  ad_supplier_group_id: number
  account: string
  user_name: string
  email?: string
  phone?: string
  user_role_id?: number
}

interface UpdateAdSupplierGroupUserRequest {
  user_role_id?: number | null
}

export const adSupplierGroupUsersService = {
  updateAdSupplierGroupUser: async (
    id: number,
    data: UpdateAdSupplierGroupUserRequest,
    token: string,
  ): Promise<AdSupplierGroupUserResponse> => {
    try {
      const response = await apiClient.put<AdSupplierGroupUserResponse>(
        `/api/ad-supplier-group-users/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as AdSupplierGroupUserResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'UPDATE_AD_SUPPLIER_GROUP_USER_FAILED',
          message: '更新廣告商集團使用者失敗',
        },
      }
    }
  },

  deleteAdSupplierGroupUser: async (
    id: number,
    token: string,
  ): Promise<AdSupplierGroupUserResponse> => {
    try {
      const response = await apiClient.delete<AdSupplierGroupUserResponse>(
        `/api/ad-supplier-group-users/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as AdSupplierGroupUserResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'DELETE_AD_SUPPLIER_GROUP_USER_FAILED',
          message: '刪除廣告商集團使用者失敗',
        },
      }
    }
  },

  createAdSupplierGroupUserByAccount: async (
    data: CreateAdSupplierGroupUserByAccountRequest,
    token: string,
  ): Promise<AdSupplierGroupUserResponse> => {
    try {
      const response = await apiClient.post<AdSupplierGroupUserResponse>(
        '/api/ad-supplier-group-users/by-account',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as AdSupplierGroupUserResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'CREATE_AD_SUPPLIER_GROUP_USER_FAILED',
          message: '建立廣告商集團使用者失敗',
        },
      }
    }
  },

  createNewUserAndAddToGroup: async (
    data: CreateNewUserAndAddToGroupRequest,
    token: string,
  ): Promise<AdSupplierGroupUserResponse> => {
    try {
      const response = await apiClient.post<AdSupplierGroupUserResponse>(
        '/api/ad-supplier-group-users/new-user',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as AdSupplierGroupUserResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'CREATE_NEW_USER_FAILED',
          message: '建立新使用者失敗',
        },
      }
    }
  },
}
